module.exports = __webpack_public_path__ + "img/avatar4.57d519b9.png";